/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Registry_Lv_IdInputs */

const cs_property_registry_lv_id = /** @type {(inputs: Property_Registry_Lv_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID LV (volitelné)`)
};

const en_property_registry_lv_id = /** @type {(inputs: Property_Registry_Lv_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LV ID (optional)`)
};

/**
* | output |
* | --- |
* | "LV ID (optional)" |
*
* @param {Property_Registry_Lv_IdInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_lv_id = /** @type {((inputs?: Property_Registry_Lv_IdInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_Lv_IdInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_lv_id(inputs)
	return cs_property_registry_lv_id(inputs)
});